import { Component, OnInit } from '@angular/core';
import { associateDocList } from '@app/_models/associateDocList';
import { LogService } from '@app/_shared/log.service';

@Component({
  selector: 'app-associate-supervisor',
  templateUrl: './associate-supervisor.component.html',
  styleUrls: ['./associate-supervisor.component.less']
})
export class AssociateSupervisorComponent implements OnInit {
  public routeVal = '';
  receiveVal($event) {
    this.routeVal = $event;
  }
  constructor(private eventService: LogService) { }
  response: any;
  public newData = '' 
  id;
  associateData: associateDocList;

  ngOnInit() {
   
    this.eventService.on<string>().subscribe(
      data => {
        this.response = data;
        console.log(this.response + "dataValue")
        if (this.response.dataValue == 1) {
          this.response = data;
          this.newData = this.response.dataValue;
          this.associateData = this.response.data;
          console.log( "collegeData ,..."+ this.response)
        }
        else {
          this.newData = data
        }
      

        this.routeVal = this.newData
        console.log(this.newData + "final")
      }
    )
  
  }

}
